import { clockSkewEnhancer } from '../../enhancers/clockSkew.js';
import { retryEnhancer } from '../../enhancers/retry/index.js';
import { signingEnhancer } from '../../enhancers/signing/index.browser.js';
import { timeoutEnhancer } from '../../enhancers/timeout.js';
import { trackingUuidEnhancer } from '../../enhancers/trackingUuid.js';
import { fromBabbelSession } from '../../fromBabbelSession.js';
import { withDefaults } from '../index.browser.js';

import type { FetchConfig } from '../../types/fetchEnhancer.js';

/**
 * Fetch configured for Babbel's API Gateway endpoints with sigv4 auth.
 */
export const fetch = withDefaults(
  trackingUuidEnhancer(
    retryEnhancer(clockSkewEnhancer(signingEnhancer(timeoutEnhancer(globalThis.fetch)))),
  ),
  {
    awsCredentials: fromBabbelSession(),
  },
);

/**
 * Possible configuration options for {@link fetch}
 */
export type Config = FetchConfig<typeof fetch>;

export { fromBabbelSession, SessionConfig } from '../../fromBabbelSession.js';
export * from '../../enhancers/clockSkew.js';
export * from '../../enhancers/signing/index.browser.js';

export * from '../../main.js';
